import { Dashboard } from "@mui/icons-material";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "src/app/reduxCustomHooks";
import MainTemplate from "src/components/template/MainTemplate";

export default function PrivateRoute() {
  const auth = useAppSelector(({ auth }) => auth);
  return auth?.token ? (
    <MainTemplate>
      <Outlet />
    </MainTemplate>
    
  ) : (
    <Navigate to="/login" />
  );
}
